import React, { useReducer } from "react";
import { useTranslation } from "react-i18next";
import {
  TitleTemplatePure,
  Container,
  Stepper,
  SimpleLoading,
  NotificationPure,
  DialogSystemGLPure,
  PromotionalFooterPure,
  HeaderHLPure,
} from "../../pures";
import DialogDeleteSignerPure from "../../pures/dialog-delete-signer/dialog-delete-signer.pure";
import "./signature-request-profile.css";
import { Grid } from "@material-ui/core";

const filterSignatures = (state, action) => {
  let newState = []
  if (state.length > 0 && action.dataItem.length > 0) {
    action.dataItem.map(element => {
      let coordinates = state.filter(signature => signature.email === element.email)
      coordinates.map(coordinate => {
        newState.push(coordinate)
      })
    });
  }
  return newState
};


function reducer(state, action) {
  switch (action.type) {
    case "setSignatures":
      return [...state]
    case "deleteSignatures":
      return filterSignatures(state, {
        dataItem: action.payload
      })
    case "deleteSignatureByIndex":
      let signs = state
      const newSigns = signs.splice(action.index, 1)
      return [...signs]
    case "deleteOwnSignatures":
      let signatures = [...state]
      signatures = signatures.filter(item => item.email !== action.payload)
      return signatures
    default:
      return {}
  }
}

const SignatureRequestProfileView = (props) => {
  const [signatures, dispatch] = useReducer(reducer, []);

  const { t } = useTranslation();
  const { selectedStep, stepMetadata, steps, loading } = props;
  const step = steps[selectedStep];
  const { component: StepComponent, back, next } = stepMetadata[selectedStep];
  // const title = `${step.title}.`
  // const subtitle = `
  //   ${t('configurationPlanRenovationView.steps')} ${selectedStep + 1}
  //   ${t('configurationPlanRenovationView.of')} ${steps.length}
  // `

  return (
    <>
      <Container>
        <Grid className="standard-wrapper" container spacing={2}>
          <Grid item xs={12}>
            <HeaderHLPure title={t("signatureRequestProfileView.titleSignatureRequestProfile")} />
          </Grid>
          <Grid item xs={12}>
            <Stepper steps={steps} selectedStep={selectedStep} />
          </Grid>

          <Grid item xs={12} className="container-step-sigatureRequestProfile">
            {loading ? (
              <div className="step-description-sigatureRequestProfile">
                <SimpleLoading />
              </div>
            ) : (
              <StepComponent
                step={step}
                onHandleNext={next}
                onHandleBack={back}
                signatures={signatures}
                dispatch={dispatch}
                {...props}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            <PromotionalFooterPure />
          </Grid>
        </Grid>
      </Container>
      {/* Notificacion alert */}
      <NotificationPure
        notification={props.showNotification}
        type={props.notification.type}
        style={props.notification.style}
        onClose={props.onCloseOpenModal}
        message={props.message}
      />

      {/* Alerts of Notification Completed and Loadign */}
      <DialogSystemGLPure
        {...props}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
        showErrorRequesting={props.showErrorRequesting}
        // toggleErrorDomain={props.toggleErrorDomain}
        message={props.message}
        cancel={props.cancel}
        handleSubmitConfirm={props.handleSubmitConfirm}
      />
      {/* Dialog Delete Signer */}
      <DialogDeleteSignerPure
        {...props}
        remove={props.remove}
        toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
      />
    </>
  );
};

export { SignatureRequestProfileView as default };
